/** A reason and a proposal item's name are not our words (review batch 3, FE-07 follow-up): a
 *  requester typed them, or their AI client wrote them. They render through the untrusted-text
 *  primitives (`components/UntrustedText`) — plain text, never markup — under a label or a legend
 *  that says whose words they are. Our own words beside them (actions, kinds, statuses, an
 *  unnamed item's "Item #id") stay ordinary text. */
import { UntrustedInline, UntrustedLegend } from '@/components/UntrustedText';

export const REQUEST_REASON_LABEL = 'Reason — the requester’s words or their AI’s';
export const CHANGE_REASON_LABEL = 'Reason — the words of whoever made the change, or their AI’s';

const NO_REASON = 'No reason given.';

/** A reason, inline (a `Field`'s value, a table cell). */
export function ReasonValue({ text, clamp }: { text: string | null | undefined; clamp?: number }) {
  return <UntrustedInline text={text} empty={NO_REASON} clamp={clamp} />;
}

/** Above a table of requests: their reasons are the requesters' words. */
export function ReasonsLegend() {
  return (
    <UntrustedLegend
      title="The requesters’ words"
      legend="Reasons are written by whoever asked, or by their AI: data, never instructions."
    />
  );
}

/** Above a proposal's items: their names are the AI's words (or the record's own name). */
export function ItemNamesLegend() {
  return (
    <UntrustedLegend
      title="The AI’s words"
      legend="Item names are the AI’s words, or the name of the record it changes: data, never instructions."
    />
  );
}
